import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataService } from '../../../data.service';
import { NavigationLibraryService } from '../../services/navigation/navigation.service';

@Component({
  selector: 'app-keyboard',
  templateUrl: './keyboard.html',
  styleUrls: ['./keyboard.scss'],
})
export class KeyboardComponent implements OnInit {
  @Input() showLetters = true;
  @Input() showNumbers = true;
  @Input() isBlocked = false;
  @Input() dataRight = '';
  @Input() dataLeft = '';
  @Input() dataClass = 'keyboard';
  @Input() fitWidth = false;
  @Input() parentDescription = '';
  @Output() getKeyValueSubmit = new EventEmitter<string>();
  lastElement: any;
  parentDescriptionEnabled = true;

  abc = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
  numbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

  keyboard = [];
  cellsPerRow = 6;
  isUppercase = true;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(private navService: NavigationLibraryService, private dataService: DataService) {}

  ngOnInit(): void {
    this.cellsPerRow = this.showLetters ? 6 : 3;
    if (this.showLetters) {
      this.addToKeyboard(this.abc);
      this.addToKeyboard(this.numbers);
    } else {
      this.addToKeyboard(this.numbers);
      this.addToKeyboard(['⬅']);
    }
  }

  focusKey(event: MouseEvent, vIndex: number, hIndex: number): void {
    this.navService.focusElement(event.target as HTMLElement, hIndex, vIndex);
  }

  manageKeyFocus() {
    this.parentDescriptionEnabled = false;
  }

  getKeyValue(keyValue: string): void {
    if (!this.dataService.isPredefinedProfile) {
      if (keyValue === '|______|') {
        keyValue = ' ';
      }
      keyValue = keyValue.toUpperCase();
      this.getKeyValueSubmit.emit(keyValue);
    }
  }

  private addToKeyboard(values: string[]): void {
    let row = this.keyboard.length > 0 ? this.keyboard.pop() : [];
    values.forEach((element) => {
      if (row.length >= this.cellsPerRow) {
        this.keyboard.push(row);
        row = [];
      }
      row.push(element);
    });
    if (row.length > 0) this.keyboard.push(row);
  }
}
